<!-- start app-label -->
<label [for]="for" [class]="class ? class : null" [style]="style">
    {{title || 'المسمي'}} <ng-container *ngIf="required"><span class="marked_required text-danger">*</span></ng-container>
</label>
<!-- end app-label -->